import Navbar from "./Navbar.jsx";
import Hero from "./Hero.jsx";
import Problem from "./Problem.jsx";
import Steps from "./Steps.jsx";
import Moments from "./Moments.jsx";
import Anywhere from "./Anywhere.jsx";
import Platform from "./Platform.jsx";
import Feeling from "./Feeling.jsx";
import Partner from "./Partner.jsx";
import Trust from "./Trust.jsx";
import FAQ from "./FAQ.jsx";
import CTA from "./CTA.jsx";
import BottomBar from "./BottomBar.jsx";
import StickyDownload from "./StickyDownload.jsx";
import Flexibility from "../SSPnew/Flexibility.jsx";
import ReturnsDiscount from "./ReturnsDiscount.jsx";
import RDReturns from "./RDReturns.jsx";

export default function SSPnew() {
  return (
    <div className="bg-white font-montserrat text-[#0d0828]" style={{ overscrollBehaviorY: 'none', WebkitOverflowScrolling: 'touch' }}>
      <Navbar />
      <Hero />

      <Platform />
      <RDReturns />
       <Moments />
      <Problem />
      {/* <Flexibility /> */}
      {/* <Steps /> */}
    
      {/* <Anywhere /> */}
      
      <Feeling />
      <Partner />
      <Trust />
      <FAQ />
      <CTA />
      {/* <BottomBar /> */}
      {/* <StickyDownload /> */}
    </div>
  );
}
